module.exports = __webpack_public_path__ + "static/img/Healing-02.102f254.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue14/Healing Moment/Healing-02.jpg
// module id = UR/J
// module chunks = 7